import type { ConsensusDirection } from '.';
import type { ConsensusRating } from '@thinkalpha/quant-ws-client/contracts/analyst-ratings.js';

const ORDER: Record<ConsensusRating, number | null> = {
    strong_sell: -2,
    sell: -1,
    hold: 0,
    buy: 1,
    strong_buy: 2,
    mixed: null,
    none: null,
};

export const CONSENSUS_LABEL: Record<ConsensusRating, string> = {
    strong_buy: 'Strong Buy',
    buy: 'Buy',
    hold: 'Hold',
    sell: 'Sell',
    strong_sell: 'Strong Sell',
    mixed: 'Mixed',
    none: 'No Coverage',
};

export function consensusDirection(curr: ConsensusRating, prior: ConsensusRating): ConsensusDirection {
    const base = { from: CONSENSUS_LABEL[prior], label: CONSENSUS_LABEL[curr], current: curr } as const;
    if (curr === prior) return { ...base, arrow: 'unchanged' };
    const a = ORDER[curr];
    const b = ORDER[prior];
    if (a === null || b === null) return { ...base, arrow: 'flat' };
    if (a > b) return { ...base, arrow: 'up' };
    if (a < b) return { ...base, arrow: 'down' };
    return { ...base, arrow: 'flat' };
}
